import { createContext } from 'react';

import { TPermissionsContextValue } from '@/shared/features/permissions/context/permissions-context.types';

// Default is permissive: where no provider is mounted, checks resolve to true so
// this stack never gates an app that has not adopted it.
export const PermissionsContext = createContext<TPermissionsContextValue>({
  model: null,
  isLoading: false,
});
